module.exports = __webpack_public_path__ + "img/logo_Q_VisualizationTool.aa2a6b33.svg";